// extracted by mini-css-extract-plugin
module.exports = {"service":"service-module--service--1g83Q","imageWrapper":"service-module--imageWrapper--2h96o","image":"service-module--image--2yAsG"};